import React, { useEffect, useState } from 'react';
import '../styles/Loder.css';
import bgImage from '../assets/xai-future-artificial-intelligence-robot-cyborg_31965-292512.avif';

const Loder = () => {
  const [hide, setHide] = useState(false);
  const [remove, setRemove] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setHide(true), 2000); // wait 2s before fade-out
    const timer2 = setTimeout(() => setRemove(true), 3000); // wait another 1s to remove fully

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  if (remove) return null;

  return (
    <div className={`image-loader ${hide ? 'fade-out' : ''}`}>
      <img src={bgImage} alt="Loader Background" className="loader-image" />
      <h2 className="loader-text top swipe-left">Think Automation</h2>
      <h2 className="loader-text bottom swipe-right">Think FU-TEK</h2>
    </div>
  );
};

export default Loder;
